import React from 'react';
import { Link } from 'react-router-dom';

export default function ForbiddenPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-[#f8faf5] px-4 py-16">
      <div className="max-w-lg w-full text-center bg-[#eef4e6] p-8 sm:p-12 rounded-3xl border border-[#d9e5d4] shadow-xs space-y-6">
        
        <div className="w-16 h-16 mx-auto rounded-full bg-[#E09F3E]/15 text-[#B87A20] flex items-center justify-center text-3xl">
          <i className="fa-solid fa-lock text-2xl" aria-hidden="true" />
        </div>

        <div>
          <span className="text-xs font-bold uppercase tracking-wider text-[#B87A20]">Fejl 403</span>
          <h1 className="text-3xl sm:text-4xl font-bold text-[#1D2923] tracking-tight font-serif-heading mt-1">
            Adgang ikke tilladt
          </h1>
          <p className="text-sm text-[#5A6961] mt-3 leading-relaxed">
            Du har desværre ikke adgang til denne side eller ressource. Kontakt administrationen, hvis du mener der er tale om en fejl.
          </p>
        </div>

        <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm font-bold text-[#1D2923] bg-[#c1d8e5] hover:bg-[#aecad9] transition-colors shadow-xs"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm font-semibold text-[#264A35] bg-white hover:bg-[#f8faf5] border border-[#d9e5d4] transition-colors"
          >
            <span>Kontakt skolen</span>
          </Link>
        </div>

      </div>
    </div>
  );
}
